import type { AppConfigUpserter } from '@cognite/apm-config';
import { makeToast } from '@cognite/cogs-lab';
import type { CogniteClient } from '@cognite/sdk';
import { getAppConfigClient } from '@infield/features/app-config/utils';
import { captureException } from '@sentry/browser';
import { createContext } from 'react';

export interface UseUpsertAppConfigMutationContextInterface {
  makeToast: typeof makeToast;
  captureException: typeof captureException;
  getAppConfigClient: (
    cogniteClient: CogniteClient,
    schemaVersionOverride?: number
  ) => AppConfigUpserter;
}

export const defaultValue: UseUpsertAppConfigMutationContextInterface = {
  makeToast,
  captureException,
  getAppConfigClient,
};

export const UseUpsertAppConfigMutationContext =
  createContext<UseUpsertAppConfigMutationContextInterface>(defaultValue);
